<template>
  <Modal
    :showModal="showModal"
    @close="$emit('close')"
    class="modal-cart-account-registration text-center"
    :class="{ 'modal-cart-account-registration--two-col': isGuest }"
  >
    <template v-slot:body>
      <div class="modal-cart-account-registration__row">
        <div
          class="modal-cart-account-registration__col"
          :class="{ 'modal-cart-account-registration__col--single': !isGuest }"
        >
          <h3 class="text-h3">{{ $t('cart.reviewStep.confirmationTitle') }}</h3>
          <p class="modal-cart-account-registration__message" v-if="orderConfirmationData">
            <i18n path="cart.reviewStep.confirmationMessage">
              <router-link
                v-if="!isGuest"
                :to="orderConfirmationData.link"
                @click.native="$emit('close', orderConfirmationData.link)"
                class="text-underline"
              >
                {{orderConfirmationData.id}}
              </router-link>
              <span v-else>{{orderConfirmationData.id}}</span>
              <span>{{orderConfirmationData.customerUid}}</span>
            </i18n>
          </p>
          <div class="modal__actions">
            <button
              type="button"
              class="button button--primary"
              @click="$emit('close', '/')"
            >
              {{ $t('cart.modal.continueShopping') }}
            </button>
          </div>
        </div>
        <div v-if="isGuest" class="modal-cart-account-registration__col modal-cart-account-registration__col--right">
          <h3 class="text-h3">{{ $t('cart.reviewStep.createHubbellAccount')}}</h3>
          <p class="modal-cart-account-registration__message" v-if="orderConfirmationData">
            {{ $t('cart.reviewStep.confirmationMessageGuest') }}
          </p>
          <div class="modal__actions">
            <button
              type="button"
              class="button button--primary"
              @click="doSignup"
            >
              {{ $t('cart.reviewStep.createAccount')}}
            </button>
          </div>
        </div>
      </div>
    </template>
  </Modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import Modal from '@/components/modal/Modal'

export default {
  name: 'ModalOrderConfirmation',
  components: {
    Modal
  },
  props: ['orderConfirmationData', 'showModal'],
  computed: {
    ...mapGetters('user', ['isGuest'])
  },
  methods: {
    ...mapActions('app', ['doSignup'])
  }
}
</script>
